import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { Label } from "ui/shared/components/form/Layout";
import { isEmpty } from "lodash";
import { validate } from "data/account/validators/sign_in";
import Input from "ui/shared/components/form/Input";
import FieldContainer from "ui/shared/containers/form/FieldContainer";
import ErrorContainer from "ui/shared/containers/form/ErrorContainer";
import { NextButton, Button } from "ui/shared/components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { showForgotPassword, showEmailVerification } from 'data/account/actions/signInModal';
import { submitSignIn } from 'data/account/actions/signIn';

export default function SignIn() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email, targetUrl } = useSelector(state => state.account.signInModal)
    const error = useSelector(state => state.account.signIn.error);
    const handleForgotPassword = () => {
        dispatch(showForgotPassword(email));
    }

    return (
        <div className={"space-y-4 flex flex-col max-w-[400px] text-justify"}>
            <h2 className="text-xl font-bold">{t('account_button.log_in')}</h2>
            <div className='self-start flex items-center gap-2'>
                <Button onClick={() => { dispatch(showEmailVerification(email)) }} icon={"long-arrow-left"} className={"w-6 h-6 flex justify-center items-center bg-gray-200 hover:bg-gray-400 rounded-full"} />
                <p>{email}</p>
            </div>
            <Form
                onSubmit={(values) => dispatch(submitSignIn(values))}
                initialValues={{
                    email: email,
                    password: null,
                    _target_path: targetUrl
                }}
                validate={validate}
            >
                {({ handleSubmit, pristine, submitting, invalid }) => {
                    return (
                        <form className="lg:w-[400px]" onSubmit={handleSubmit}>
                            {!isEmpty(error) &&
                                <div className="bg-red-700 p-4 text-white mb-2 opacity-75 rounded-md" role="alert">
                                    {t('account_button.login_error')}
                                </div>
                            }
                            <div className={"space-y-8"}>
                                <section className="flex flex-col gap-8">
                                    <FieldContainer name="password" className="w-full">
                                        <div>
                                            <Label htmlFor="password">{t('account_button.enter_your_password')}</Label>
                                            <Field
                                                className="form-control"
                                                id="password"
                                                name="password"
                                                type="password"
                                                component={Input}
                                                placeholder={t('account_button.password')}
                                            />
                                        </div>
                                        <ErrorContainer name="password" className="help-block" />
                                        <div className="pt-2">
                                            <a onClick={handleForgotPassword} className="text-orange-500 cursor-pointer hover:text-orange-700 hover:underline">
                                                {t('account_button.forgot_password')}
                                            </a>
                                        </div>
                                    </FieldContainer>
                                </section>
                                <FieldContainer form="sign_up" name="cgv">
                                    <ErrorContainer form="sign_up" name="cgv" />
                                </FieldContainer>

                            </div>

                            <div className="flex justify-end">
                                <NextButton
                                    type="submit"
                                    disabled={pristine || submitting}
                                    loading={submitting}
                                    icon={pristine || submitting ? "ban" : "check"}
                                    className="w-full my-5 rounded-md justify-self-end"
                                >
                                    {t('account_button.next')}
                                </NextButton>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    )
}